import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jira-issue-view-child-issues-panel-issuesearch');
	},
};
